module.exports = __webpack_public_path__ + "img/1528696123.0c54a943.jpg";